import App from './App'
import render from 'commons/js/util/render'
import { init } from 'commons/js/util/reporter'

init()

const element = document.querySelector('.js-sticky')
const parsedTabs = JSON.parse(element.dataset.tabs)
const parsedElements = JSON.parse(element.dataset.elements)
const referenceElement = parsedElements.map((parsedElement) => {
    return {
        name: parsedElement.name,
        target: document.querySelector(parsedElement.target),
    }
})
const dataProps = {
    tabs: parsedTabs,
    elements: referenceElement,
}
render({ App, element, props: { ...dataProps } })
